<template>
  <b-container fluid class="competition-frame">
    <b-row class="competition-top-row-position step2-name">
      <h2>{{ stepOneValues.name }}</h2>
    </b-row>
    <b-row class="competition-top-row-position step2-code">
      <p>{{ stepOneValues.code }}</p>
    </b-row>
    <b-row>
      <b-col md="1">
        <competition-step-progress />
      </b-col>
      <b-col md="11">
        <div class="accordion" role="tablist">
          <div no-body class="mb-1 condition-main">
            <div header-tag="header" class="p-1 competition-accordion-header" role="tab">
              <b-link class="competition-accordion-button" v-b-toggle="'competiton-accordion-filter'">
                <ChevronUpIcon class="competition-accordion-icon" />
                <p class="accordion-header-title">Összetett Feltételek</p>
              </b-link>
            </div>
            <b-collapse id="competiton-accordion-filter" visible accordion="my-accordion" role="tabpanel">
              <div class="condition-body">
                <complex-filter-selector
                  :items="complexFilters"
                  :onChanged="onComplexFilterChanged"
                  :selectedItems="stepThreeValues.complexFilters"
                />
              </div>
            </b-collapse>
          </div>
        </div>

        <company-fields
          v-if="!competitionLoading"
          :onChanged="onFieldValueChanged"
          :getFieldFormErrors="getFieldFormErrors"
          :fields="stepThreeValues.fieldForms"
        />
        <b-row class="competition-step-button-row mt-2">
          <b-button class="competition-step-button back" @click="goBack">Előző lépés</b-button>
          <b-button class="competition-step-button" @click="save">Tovább</b-button>
        </b-row>
      </b-col>
    </b-row>
    <go-back-popup :step="2" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyFields from './CompanyFieldComponents/CompanyFields.vue'
import CompetitionStepProgress from './CompetitionStepProgress.vue'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue'
import ComplexFilterSelector from './ComplexFilterSelector.vue'
import { listComplexFilters } from '../../../api/complexFilter'
import GoBackPopup from '../../../components/GoBackPopup.vue'
export default {
  components: { ChevronUpIcon, CompanyFields, CompetitionStepProgress, ComplexFilterSelector, GoBackPopup },
  name: 'CompetitionStepThree',
  data: function() {
    return { complexFilters: [] }
  },
  created: async function() {
    this.$store.commit('resetState')
    this.$store.dispatch('loadFieldForms').then(async () => {
      this.$store.commit('setStep', 3)
      if (this.$route.query.competitionId) {
        const { competitionId } = this.$route.query
        await this.$store.dispatch('getCompetition', { step: 3, competitionId })
        const complexFilters = await listComplexFilters()
        this.complexFilters = complexFilters.map(cf => ({ _id: cf._id, name: cf.name }))
      } else {
        this.$router.push('not-found-page')
      }
    })
  },
  mounted() {
    this.$store.commit('clearIsModified')
  },
  computed: {
    ...mapGetters([
      'isModified',
      'stepOneValues',
      'stepThreeValues',
      'stepThreeErrors',
      'getFieldFormErrors',
      'competitionLoading'
    ])
  },
  methods: {
    goBack: function() {
      if (this.isModified) {
        this.$root.$emit('bv::show::modal', 'goback-popup')
      } else {
        const path = `/competitions/competition/2`
        this.$router.push({ path, query: { competitionId: this.$route.query.competitionId } })
      }
    },
    save: function() {
      this.$store.dispatch('saveCompetition', { step: 3 })
    },
    onChanged: function(key, value) {
      this.$store.commit('setIsModified')
      this.$store.commit('setValue', { step: 'stepThree', key, value })
    },
    onComplexFilterChanged: function(complexFilters) {
      this.$store.commit('setIsModified')
      this.onChanged('complexFilters', complexFilters)
    },
    onFieldValueChanged: function(value, conditionIndex) {
      this.$store.commit('setIsModified')
      this.$store.commit('setFieldForm', { value, conditionIndex })
    }
  }
}
</script>

<style>
.accordion {
  /* border-bottom: 1px solid lightgrey; */
}
.accordion-header-title {
  margin: 0;
  padding-left: 30px;
  font-size: 16px;
  color: #2d3436;
  font-weight: 700;
  display: inline;
}
.panel-heading.collapsed .fa-chevron-down,
.panel-heading .fa-chevron-right {
  display: none;
}

.panel-heading.collapsed .fa-chevron-right,
.panel-heading .fa-chevron-down {
  display: inline-block;
}

i.fa {
  cursor: pointer;
  margin-right: 5px;
}

.competition-accordion-button {
  display: flex;
  background-color: transparent;
  border: none;
  text-decoration: none;
  color: #000;
  display: inline;
  float: left;
}
.competition-accordion-button:hover {
  text-decoration: none;
  color: #000;
}
.competition-accordion-header {
  background-color: transparent;
}
a[aria-expanded='true'] .competition-accordion-icon > svg {
  transform: rotate(180deg);
}

.competition-accordion-icon > svg {
  color: #000;
  transition-duration: 0.5s;
}

.collapsed ~ .panel-body {
  padding: 0;
}

.condition-main {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.condition-body {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}
</style>
